import { t } from "../../../i18n";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import logo from '../../../assets/images/logos/ConnectedHeart_Logo_Branco.svg';
export default function LogoSection({
  onNavigate
}) {
  return <ButtonBase component={Link} to="/" onClick={onNavigate} aria-label={t("ConnectedHeart — Início")}>
            <img src={logo} alt={t("ConnectedHeart")} width="100%" />
        </ButtonBase>;
}
LogoSection.propTypes = {
  onNavigate: PropTypes.func.isRequired
};
